<template>
  <div
    class="w-100 h-100 p-3 overflow-auto bg-customize"
    :style="`background: rgba(${rGBaCode}); border-color: rgba(${rGBaCode})`"
  >
  <Loading v-show="loading" />
    <MethodsAndTerms v-if="showTerms" />
    <div class=" d-flex align-items-center " v-else style="min-height:100%;">
      <!-- 獲取積點 begin -->
      <div class="container mx-auto py-3 px-4 rounded shadow-custom mcf-light" style="max-width:640px;"><!-- 遮罩 -->
        <div class="text-center d-flex h-100 align-items-center flex-column">
          <!-- 積點名稱/圖片 begin -->
          <div class="my-4">
            <h6 class="font-weight-normal text-mcf-color">{{$t('qrcode-get-coupon.verification.title')}}</h6>
            <h3 class="font-weight-normal text-mcf-color">{{couponName}}</h3>
            <div class="m-auto image-panel image-panel-5 bg-none my-2">
              <img :src="couponImage" alt="" :title="couponName">
            </div>
          </div>
          <!-- 積點名稱/圖片 end -->
          <!-- 表單 begin -->

          <div class="w-100 text-left">
            <!-- 左國碼右手機號碼 begin -->
          <b-form-group>
            <Mobile
              :required="true"
              :editable="true"
              :disabled="!mobileEditable"
              :answer="mobileData"
              @updateData="updateData"
              @validateDone="validateAgain"
              ref="mobile"
            />
          </b-form-group>
          <b-button
            block
            :variant="isDisabledSend ? 'light' : '' "
            :class="{'bg-customize border-customize': !isDisabledSend}"
            v-if="!isHiddenFirstSend"
            :disabled="isDisabledSend"
            @click="checkAccountID"
            :style="`background: rgba(${rGBaCode}); border-color: rgba(${rGBaCode}); color: white`"
            >{{ $t("qrcode-get-coupon.verification.press-phone-number.send-verification-code") }}</b-button
          >
          <!-- 左國碼右手機號碼 end -->
          <b-form-group>
            <VerifyCode
              v-if="isHiddenFirstSend"
              :maxLength="6"
              @checkVerify="callMobileVerifycodeVerifier"
              ref="verifyCode"
            />
            <div
              class="mb-1 d-flex justify-content-end align-items-center"
              v-if="isHiddenFirstSend"
            >
              <div class="font-size-md">
                <span v-if="!isOutTime"
                  >{{ stillHaveTotalSec
                  }}{{ $t("qrcode-get-coupon.verification.verification-code-validate.countdown-send-again") }}</span
                >
                <a
                  v-if="isOutTime"
                  href="javascript:void(0)"
                  @click="
                    checkAccountID();
                    validateState = undefined;
                    return false;
                  "
                  class="te-float-font"
                  ><u>{{ $t("qrcode-get-coupon.verification.verification-code-validate.send-again") }}</u></a
                >
              </div>
            </div>
          </b-form-group>
            <div class="mt-3 text-right font-size-md">{{ $t("qrcode-get-coupon.verification.agree-member-policy.agree-to-verify") }}
              <a href="javascript:void(0)" @click="setShowTerms('membership-terms')"><u>{{ $t("qrcode-get-coupon.verification.agree-member-policy.member-policy") }}</u></a></div>
          </div>
          <!-- 表單 end -->
          <!-- 活動辦法 begin -->
          <div class="w-100 mt-5 text-left text-mcf-color font-size-md text-break-word">
            <h6>{{ $t("qrcode-get-coupon.verification.description") }}</h6>
            <p>{{ $t("qrcode-get-coupon.verification.coupon-description.title") }}{{ couponDesc }}</p>
            <p v-html="$t('qrcode-get-coupon.verification.instructions-for-use.title') + limitDesc"></p>
            <p>{{ $t("qrcode-get-coupon.verification.receive-limit.title") }}{{ limit ? $t("qrcode-get-coupon.verification.receive-limit.limit-amount", { amount: couponLimitCnt }) : $t("qrcode-get-coupon.verification.receive-limit.no-limit")}}</p>
            </div>
          <!-- 活動辦法 end -->
        </div>
      </div>
      <!-- 獲取積點 end -->
    </div>
  </div>

</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import Mobile from '@/views/qrCode/Mobile.vue';
import VerifyCode from '@/views/qrCode/VerifyCode.vue';
import mmsService from '@/services/mmsService';
import MethodsAndTerms from '@/components/MethodsAndTerms.vue';
import Loading from '@/components/Loading.vue';

export default {
  data() {
    return {
      mobileData: {
        callingCode: '',
        mobile: '',
        mobileCountry: '',
      },
      isHiddenFirstSend: false,
      isDisabledSend: true,
      limitedAgainSendTime: '',
      validateState: undefined,
      errorMessage: '',
      stillHaveTotalSec: 0,
      timer: null,
      EndTime: '',
      isOutTime: false,
      mobileEditable: true,
      no: 0,
      activityNo: 0,
      universalCompanyTagNo: [],
      detailCompanyTagNo: [],
    };
  },
  components: {
    Mobile,
    VerifyCode,
    MethodsAndTerms,
    Loading,
  },
  created() {
    const vm = this;
    const { companyId, unionId } = vm.$route.query;

    this.set({ name: 'loading', value: true });
    mmsService.getQrCodeActivity({ companyId, unionId })
      .toPromise()
      .then((getQrCodeActivityRes) => {
        // 若查不到資料，導向錯誤頁
        if (getQrCodeActivityRes.response.status !== '200') {
          vm.$router.replace({ name: 'Error', params: { status: 'activityNotExist' } });
        }
        const qrCodeActivity = getQrCodeActivityRes.response.data[0];
        vm.unionId = unionId;
        for (let u = 0; u < qrCodeActivity.universalTags.length; u += 1) {
          vm.universalCompanyTagNo.push(qrCodeActivity.universalTags[u].no);
        }

        this.set({ name: 'companyId', value: qrCodeActivity.companyId });
        this.set({ name: 'memberSourceId', value: qrCodeActivity.memberSourceId });
        this.getMemberSourceSetting();
        this.getPageSetting('MemberCentreHomePage');

        this.set({ name: 'couponNo', value: qrCodeActivity.couponNo });
        this.set({ name: 'activityNo', value: qrCodeActivity.no });
        this.set({ name: 'activityName', value: qrCodeActivity.name });
        this.postWording();

        if (qrCodeActivity.startTime > Date.now() || qrCodeActivity.endTime < Date.now()) {
          vm.$router.replace({ name: 'Error', params: { status: 'activityNotExist' } });
        }

        if (qrCodeActivity.typeProcessNo === 2) {
          this.set({ name: 'couponLimitCnt', value: qrCodeActivity.couponLimitCnt });
          const customizeCouponData = {
            companyId: qrCodeActivity.companyId,
            couponNo: qrCodeActivity.couponNo,
          };
          this.getPrizeCustomizeCoupon(customizeCouponData).then((getPrizeCustomizeCouponRes) => {
            if (getPrizeCustomizeCouponRes && getPrizeCustomizeCouponRes.response.success) {
              const customizeCoupon = getPrizeCustomizeCouponRes.response.data[0];
              this.set({ name: 'couponName', value: customizeCoupon.couponName });
              this.set({ name: 'couponImage', value: customizeCoupon.couponImg });
              this.set({ name: 'couponDesc', value: customizeCoupon.couponDesc });
              this.set({ name: 'limitDesc', value: customizeCoupon.limitDesc });
            }
          });
        }

        for (let d = 0; d < qrCodeActivity.detailInfo.length; d += 1) {
          if (qrCodeActivity.detailInfo[d].unionId === unionId) {
            for (let t = 0; t < qrCodeActivity.detailInfo[d].tags.length; t += 1) {
              let difTags = true;
              for (let u = 0; u < qrCodeActivity.universalTags.length; u += 1) {
                if (qrCodeActivity.universalTags[u].no === qrCodeActivity.detailInfo[d].tags[t].no) {
                  difTags = false;
                }
              }
              if (difTags === true) vm.detailCompanyTagNo.push(qrCodeActivity.detailInfo[d].tags[t].no);
            }
          }
        }
      })
      .catch(() => {
        vm.$router.replace({
          name: 'Error',
          params: { status: 'activityNotExist' },
        });
      })
      .finally(() => {
        this.set({ name: 'loading', value: false });
      });

    const getMobileVerifySettingData = {
      companyid: companyId,
      limitedAgainSendTime: 'LimitedAgainSendTime',
    };
    this.set({ name: 'loading', value: true });
    this.getMobileVerifySetting(getMobileVerifySettingData).then((res) => {
      if (res && res.response.success) {
        this.limitedAgainSendTime = res.response.data[0].value;
      }
    })
      .finally(() => {
        this.set({ name: 'loading', value: false });
      });
  },
  computed: {
    ...mapState([
      'companyId',
      'memberSourceId',
      'couponName',
      'couponImage',
      'couponDesc',
      'couponLimitCnt',
      'limitDesc',
      'showTerms',
      'memberId',
      'memberAcntNo',
      'loading']),
    ...mapState('sso', [
      'rGBaCode']),
    fullMobileNumber() {
      // 給SMS login頁的accountID
      return this.mobileData.callingCode + this.mobileData.mobile;
    },
    limit() {
      if (this.couponLimitCnt > 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions('mbc', [
      'getAccountVerifier',
      'postCustomerdataadd',
      'getMemberAccount',
      'postMemberTag',
      'postCustomerDataBind',
    ]),
    ...mapActions('sso', [
      'postMobileVerifyCode',
      'postMobileVerifycodeVerifier',
      'getMobileVerifySetting',
      'postWording',
      'getMemberSourceSetting',
      'getPageSetting',
    ]),
    ...mapActions('pmt', [
      'getPrizeCustomizeCoupon',
    ]),
    ...mapMutations(['set', 'setShowTerms']),
    checkAccountID() {
      this.getAccountVerifier(this.fullMobileNumber).then((res) => {
        if (res && (res.response.success || res.response.status === '701')) {
          this.sendVerification();
        } else {
          this.$refs.mobile.setErrorMessageFromOutside({
            errorMessage: this.$t('global.memberExist'),
            validateState: false,
          });
          // this.showPopup = true;
        }
      });
    },
    callMobileVerifycodeVerifier(verifyCode) {
      // const vm = this;
      if (this.mobileVerifycodecheck) {
        return;
      }
      this.set({ name: 'loading', value: true });
      this.mobileVerifycodecheck = true;
      const verifyData = {
        verifyTarget: this.fullMobileNumber,
        verifyCode,
      };
      this.postMobileVerifycodeVerifier(verifyData)
        .then((res) => {
          if (res && res.response.success) {
            const verifyMobileData = {
              accountType: 'Mobile',
              mobileCountry: this.mobileData.mobileCountry,
              callingCode: this.mobileData.callingCode,
              mobile: this.mobileData.mobile,
              accountId: this.fullMobileNumber,
            };

            const body = {
              accountType: verifyMobileData.accountType,
              accountId: verifyMobileData.accountId,
            };

            this.getMemberAccount(body)
              // 是會員
              .then((getMemberAccountRes) => {
                if (getMemberAccountRes && getMemberAccountRes.response.success) {
                  this.set({ name: 'memberId', value: getMemberAccountRes.response.data[0].memberID });
                  this.set({ name: 'memberAcntNo', value: getMemberAccountRes.response.data[0].account[0].memberAcntNo });

                  const postMemberTagBody = {
                    companyID: this.companyId,
                    memberID: this.memberId,
                    accountType: verifyMobileData.accountType,
                    accountID: verifyMobileData.accountId,
                    createUser: 'System',
                  };

                  const tags = this.detailCompanyTagNo;
                  this.universalCompanyTagNo.forEach((element) => {
                    tags.push(element);
                  });

                  this.postMemberTags(postMemberTagBody, tags);

                  this.$router.push({
                    name: 'McfGetPointComplete',
                    query: this.$route.query,
                  });
                }
              })
              .catch((err) => {
                // 非會員
                if (err.data.status === '605') {
                  this.postCustomerdataadd(verifyMobileData)
                    .then((postCustomerdataaddRes) => {
                      if (postCustomerdataaddRes && postCustomerdataaddRes.response && postCustomerdataaddRes.response.success) {
                        this.getMemberAccountAndPush(body, verifyMobileData);
                      } else if (postCustomerdataaddRes && postCustomerdataaddRes.data && postCustomerdataaddRes.data.status === '609') {
                        // 歸戶
                        this.postCustomerDataBind({
                          openid: verifyMobileData.accountId,
                          identifysource: verifyMobileData.accountId,
                          type: 'Mobile',
                          memberSourceID: this.memberSourceId,
                          isSubscribe: true,
                        }).then((postCustomerDataBindRes) => {
                          if (postCustomerDataBindRes && postCustomerDataBindRes.response.success) {
                            this.getMemberAccountAndPush(body, verifyMobileData);
                          }
                        });
                      }
                    })
                    .catch(() => {
                      this.mobileVerifycodecheck = false;
                    });
                }
              });
          } else {
            this.mobileVerifycodecheck = false;
          }
        })
        .catch((err) => {
          this.mobileVerifycodecheck = false;

          if (err.data.status === '605') {
            this.$refs.verifyCode.showErrorMessage(
              this.$t('qrcode-get-coupon.verification.verification-code-validate.error'),
            );
          } else if (err.data.status === '604') {
            this.$refs.verifyCode.showErrorMessage(
              this.$t('qrcode-get-coupon.verification.verification-code-validate.invalid'),
            );
          } else {
            this.$refs.verifyCode.showErrorMessage(
              this.$t('qrcode-get-coupon.verification.verification-code-validate.error'),
            );
          }
        })
        .finally(() => {
          this.set({ name: 'loading', value: false });
        });
    },
    getMemberAccountAndPush(body, verifyMobileData) {
      this.getMemberAccount(body)
        .then((getMemberAccountRes2) => {
          if (getMemberAccountRes2 && getMemberAccountRes2.response.success) {
            this.set({ name: 'memberId', value: getMemberAccountRes2.response.data[0].memberID });
            this.set({ name: 'memberAcntNo', value: getMemberAccountRes2.response.data[0].account[0].memberAcntNo });

            const postMemberTagBody = {
              companyID: this.companyId,
              memberID: this.memberId,
              accountType: verifyMobileData.accountType,
              accountID: verifyMobileData.accountId,
              createUser: 'System',
            };

            const tags = this.detailCompanyTagNo;
            this.universalCompanyTagNo.forEach((element) => {
              tags.push(element);
            });

            this.postMemberTags(postMemberTagBody, tags); // 通用貼標

            this.$router.push({
              name: 'McfGetPointComplete',
              query: this.$route.query,
            });
          }
        });
    },
    getStillHaveTotalSec() {
      this.stillHaveTotalSec = parseInt(
        (this.EndTime - new Date().getTime()) / 1000,
        10,
      );
      if (this.stillHaveTotalSec <= 0) {
        this.isOutTime = true;
        this.mobileEditable = true;
        clearInterval(this.timer);
      }
    },
    sendVerification() {
      // 初始設定
      this.isHiddenFirstSend = true;
      this.isOutTime = false;
      this.mobileEditable = false;
      // 開始倒數
      const t = new Date();
      t.setSeconds(t.getSeconds() + parseInt(this.limitedAgainSendTime, 10));
      this.EndTime = t;
      this.getStillHaveTotalSec();
      this.timer = setInterval(() => {
        this.getStillHaveTotalSec();
      }, 200);
      // 送簡訊驗證
      let payload = '';
      payload = this.fullMobileNumber;
      if (payload) {
        this.postMobileVerifyCode(payload);
      }
    },
    validateAgain() {
      this.$nextTick(() => {
        if (!this.$refs.mobile.validateState) {
          this.isDisabledSend = true;
          switch (this.$refs.mobile.errorMessage) {
            case this.$t('pleaseEnterPhoneNumberInfo'):
              this.$refs.mobile.setErrorMessageFromOutside({
                errorMessage: this.$t('qrcode-get-coupon.verification.press-phone-number.require'),
                validateState: false,
              });
              break;
            default:
              break;
          }
        } else {
          this.isDisabledSend = false;
        }
      });
    },
    updateData(data) {
      this.mobileData = data.value;
    },
    postMemberTags(body, companyTagno) {
      // 通用貼標
      const postMemberTagBody = {
        companyID: body.companyID,
        memberID: body.memberID,
        accountType: body.accountType,
        accountID: body.accountID,
        companyTagNo: companyTagno,
        createUser: body.createUser,
      };
      this.postMemberTag(postMemberTagBody);
    },
  },
};
</script>
